module.exports = __webpack_public_path__ + "img/logo-extended.27d55d2e.png";